/**
 * Read the reachability a device dashboard published.
 *
 * Both device serializers write into one merged object, so a key either
 * page might own has to be left out entirely rather than written as null -
 * whichever ran last would otherwise decide it, and the Access Point
 * serializer already carries a comment about losing the TIP flag that way.
 *
 * @param {boolean} owns whether this page is the one about a device
 * @param {*} online published reachability
 * @return {object} the key, or nothing at all
 */
export function deviceReachability(owns, online) {
	if (!owns || typeof online !== 'boolean') return {};
	return {target_online: online};
}
